webpackJsonp([219263751331854],{

/***/ 273:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _gatsbyLink = __webpack_require__(9);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _rebass = __webpack_require__(4);
	
	var _components = __webpack_require__(7);
	
	var _slices = __webpack_require__(304);
	
	var _moment = __webpack_require__(23);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var linkResolver = function linkResolver(doc) {
	  return "/" + doc.type;
	};
	
	var LandingPage = function (_React$Component) {
	  _inherits(LandingPage, _React$Component);
	
	  function LandingPage() {
	    _classCallCheck(this, LandingPage);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  LandingPage.prototype.componentDidMount = function componentDidMount() {
	    if (this.props.data.page.alternate_languages) {
	      this.context.setAltLanguages(this.props.data.page.alternate_languages);
	    } else {
	      this.context.setAltLanguages(undefined);
	    }
	  };
	
	  LandingPage.prototype.render = function render() {
	    var json = undefined;
	    if (this.props.data.page.raw) {
	      json = JSON.parse(this.props.data.page.raw);
	    }
	    var showInactive = false;
	    if (this.props.data.campaignProjects) {
	      this.props.data.campaignProjects.edges.forEach(function (edge) {
	        if (edge.node.data.status === "Inactive" || edge.node.data.status === "Canceled" || edge.node.data.status === "Archived") {
	          showInactive = true;
	        }
	      });
	    }
	    if (this.props.data.campaignProjects2) {
	      this.props.data.campaignProjects2.edges.forEach(function (edge) {
	        if (edge.node.data.status === "Inactive" || edge.node.data.status === "Canceled" || edge.node.data.status === "Archived") {
	          showInactive = true;
	        }
	      });
	    }
	    if (this.props.data.campaignProjects3) {
	      this.props.data.campaignProjects3.edges.forEach(function (edge) {
	        if (edge.node.data.status === "Inactive" || edge.node.data.status === "Canceled" || edge.node.data.status === "Archived") {
	          showInactive = true;
	        }
	      });
	    }
	    return _react2.default.createElement(
	      _rebass.Box,
	      {
	        bg: "white",
	        style: this.props.transition ? this.props.transition.style : { opacity: 0 }
	      },
	      _react2.default.createElement(_components.Head, {
	        source: {
	          meta_title: [{
	            text: json.data.seo_title !== undefined ? json.data.seo_title[0] ? json.data.seo_title[0].text : "" : ""
	          }],
	          meta_description: [{
	            text: json.data.seo_description !== undefined ? json.data.seo_description : ""
	          }],
	          social_sharing_image: {
	            url: json.data.seo_image !== undefined ? json.data.seo_image.url : ""
	          }
	        }
	      }),
	      _react2.default.createElement(
	        _components.Main,
	        null,
	        _react2.default.createElement(_components.SliceZone, {
	          content: json.data.body,
	          slices: {
	            callout_cards: _slices.CalloutCards,
	            external_updates: _slices.ExternalUpdates,
	            form: _slices.Form,
	            hero: _slices.Hero,
	            internal_updates: _slices.InternalUpdates,
	            quote: _slices.Quote,
	            rich_text: _slices.RichText,
	            side_by_side: _slices.SideBySide,
	            stats: _slices.Stats
	          },
	          sliceProps: { updates: this.props.data.updates } }),
	        (this.props.data.campaignUpdates || this.props.data.campaign2Updates || this.props.data.campaign3Updates || this.props.data.campaign4Updates) && _react2.default.createElement(
	          _components.PageSection,
	          { column: "true", borderTop: "true" },
	          _react2.default.createElement(_components.H2, {
	            children: json.lang === "en-us" ? "Related Updates" : json.lang === "es-mx" ? "Noticias" : "التحديثات ذات الصلة",
	            mb: 5,
	            fontSize: [4, 5]
	          }),
	          _react2.default.createElement(
	            _components.CardLayout,
	            { w: 1 / 1 },
	            [].concat(this.props.data.campaignUpdates ? this.props.data.campaignUpdates.edges : [], this.props.data.campaign2Updates ? this.props.data.campaign2Updates.edges : [], this.props.data.campaign3Updates ? this.props.data.campaign3Updates.edges : [], this.props.data.campaign4Updates ? this.props.data.campaign4Updates.edges : []).sort(function (a, b) {
	              if ((0, _moment2.default)(a.node.data.publish_date).utc() < (0, _moment2.default)(b.node.data.publish_date).utc()) return 1;
	              if ((0, _moment2.default)(a.node.data.publish_date).utc() > (0, _moment2.default)(b.node.data.publish_date).utc()) return -1;
	              return 0;
	            }).slice(0, 4).map(function (update, index) {
	              return _react2.default.createElement(_components.UpdateCard, { key: "project" + index, object: update.node });
	            })
	          ),
	          _react2.default.createElement(
	            _rebass.Flex,
	            { width: "100%", justify: "center" },
	            _react2.default.createElement(
	              _rebass.Box,
	              { pt: 6 },
	              _react2.default.createElement(_components.PrimaryButton, {
	                children: json.lang === "en-us" ? "View More" : json.lang === "es-mx" ? "Más noticias" : "عرض المزيد",
	                is: _gatsbyLink2.default,
	                to: "/" + this.props.data.page.lang + "/updates/?campaign=" + this.props.data.page.prismicId,
	                "aria-label": "View more updates"
	              })
	            )
	          )
	        )
	      )
	    );
	  };
	
	  return LandingPage;
	}(_react2.default.Component);
	
	LandingPage.contextTypes = {
	  setAltLanguages: _propTypes2.default.func
	};
	exports.default = LandingPage;
	var query = exports.query = "** extracted graphql fragment **";

/***/ }),

/***/ 286:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.CalloutCards = undefined;
	
	var _templateObject = _taggedTemplateLiteralLoose(["\n  position: absolute;\n  background-color: ", ";\n  opacity: 0.85;\n  top: -32px;\n  left: -24px;\n  width: calc(100% + 48px);\n  height: calc(100% + 64px);\n"], ["\n  position: absolute;\n  background-color: ", ";\n  opacity: 0.85;\n  top: -32px;\n  left: -24px;\n  width: calc(100% + 48px);\n  height: calc(100% + 64px);\n"]);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(5);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _prismicDom = __webpack_require__(10);
	
	var _rebass = __webpack_require__(4);
	
	var _components = __webpack_require__(7);
	
	var _theme = __webpack_require__(13);
	
	var _theme2 = _interopRequireDefault(_theme);
	
	var _invertTheme = __webpack_require__(12);
	
	var _invertTheme2 = _interopRequireDefault(_invertTheme);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var linkResolver = function linkResolver(doc) {
	  return "/" + doc.type;
	};
	
	var Overlay = (0, _styledComponents2.default)(_rebass.Box)(_templateObject, function (props) {
	  return props.theme.colors.violet;
	});
	
	var CalloutCards = exports.CalloutCards = function CalloutCards(props) {
	  return _react2.default.createElement(
	    _components.PageSection,
	    null,
	    _react2.default.createElement(
	      _rebass.Flex,
	      { width: 1 / 1, flexWrap: "wrap", ml: -4, mt: -4 },
	      props.items && props.items.map(function (card, index) {
	        return _react2.default.createElement(
	          _rebass.Box,
	          {
	            position: "relative",
	            width: [1 / 1, 1 / 2, 1 / 2],
	            pl: 4,
	            pt: 4,
	            key: "card-" + index,
	            height: "100%"
	          },
	          _react2.default.createElement(
	            _styledComponents.ThemeProvider,
	            { theme: index % 2 === 0 ? _invertTheme2.default : _theme2.default },
	            _react2.default.createElement(
	              _components.GradientCard,
	              { image: card.image && card.image.half.url },
	              index % 2 === 0 && _react2.default.createElement(Overlay, null),
	              _react2.default.createElement(
	                _rebass.Flex,
	                {
	                  flexDirection: "column",
	                  justifyContent: "space-between",
	                  height: "100%",
	                  style: { position: "relative" },
	                  px: [2, 4, 5]
	                },
	                _react2.default.createElement(
	                  _rebass.Flex,
	                  {
	                    flexDirection: "row",
	                    justifyContent: "space-between",
	                    alignItems: "center"
	                  },
	                  _react2.default.createElement(_components.H4, { children: "BIC | Taking Action" }),
	                  card.flag && _react2.default.createElement(
	                    _components.H4,
	                    null,
	                    card.flag
	                  )
	                ),
	                _react2.default.createElement(_components.H3, {
	                  children: card.title && card.title[0] && card.title[0].text,
	                  py: [4, 5]
	                }),
	                card.description && card.description[0] && _react2.default.createElement(_components.Article, {
	                  dangerouslySetInnerHTML: {
	                    __html: _prismicDom.RichText.asHtml(card.description, linkResolver)
	                  }
	                })
	              )
	            )
	          )
	        );
	      })
	    )
	  );
	};

/***/ }),

/***/ 287:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _CalloutCards = __webpack_require__(286);
	
	Object.keys(_CalloutCards).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _CalloutCards[key];
	    }
	  });
	});

/***/ }),

/***/ 288:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.ExternalUpdates = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _moment = __webpack_require__(23);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _components = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ExternalUpdates = exports.ExternalUpdates = function ExternalUpdates(props) {
	  return _react2.default.createElement(
	    _components.PageSection,
	    { column: "true", borderTop: "true" },
	    _react2.default.createElement(_components.H2, {
	      children: props.primary && props.primary.title && props.primary.title[0] && props.primary.title[0].text,
	      mb: 5,
	      fontSize: [4, 5]
	    }),
	    _react2.default.createElement(
	      _components.CardLayout,
	      { w: 1 / 1 },
	      props.items && props.items.sort(function (a, b) {
	        if ((0, _moment2.default)(a.date).utc() < (0, _moment2.default)(b.date).utc()) return 1;
	        if ((0, _moment2.default)(a.date).utc() > (0, _moment2.default)(b.date).utc()) return -1;
	        return 0;
	      }).map(function (update, index) {
	        return _react2.default.createElement(_components.ExternalUpdateCard, _extends({ key: "update" + index }, update));
	      })
	    )
	  );
	};

/***/ }),

/***/ 289:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _ExternalUpdates = __webpack_require__(288);
	
	Object.keys(_ExternalUpdates).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _ExternalUpdates[key];
	    }
	  });
	});

/***/ }),

/***/ 290:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.Form = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(5);
	
	var _rebass = __webpack_require__(4);
	
	var _components = __webpack_require__(7);
	
	var _invertTheme = __webpack_require__(12);
	
	var _invertTheme2 = _interopRequireDefault(_invertTheme);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Form = exports.Form = function (_React$Component) {
	  _inherits(Form, _React$Component);
	
	  function Form(props) {
	    _classCallCheck(this, Form);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.submitForm = function (e) {
	      e.preventDefault();
	      var form = document.getElementById("form");
	      var data = new FormData(form);
	      fetch("https://script.google.com/macros/s/AKfycby3m9uGtQqoBH1riLi_pz3VxvAS_m-zkrR_syIvSlQlbqOJ4izqOLg94Ya4_ZccDA4v/exec", {
	        method: "POST",
	        body: data
	      });
	      _this.setState({ submitted: true });
	    };
	
	    _this.state = {
	      submitted: false,
	      location: ""
	    };
	    return _this;
	  }
	
	  Form.prototype.componentDidMount = function componentDidMount() {
	    this.setState({ location: window.location.href });
	  };
	
	  Form.prototype.render = function render() {
	    return _react2.default.createElement(
	      _components.PageSection,
	      { column: "true", borderTop: "true" },
	      _react2.default.createElement(
	        _rebass.Box,
	        { width: 1 / 1, bg: "violet", py: [6, 7, 8], px: [6, 7, 8] },
	        this.props.primary.title && this.props.primary.title[0] && _react2.default.createElement(
	          _components.H2,
	          { mb: 4, color: "white" },
	          this.props.primary.title[0].text
	        ),
	        !this.state.submitted && _react2.default.createElement(
	          "form",
	          {
	            id: "form",
	            method: "POST",
	            action: "https://script.google.com/macros/s/AKfycby3m9uGtQqoBH1riLi_pz3VxvAS_m-zkrR_syIvSlQlbqOJ4izqOLg94Ya4_ZccDA4v/exec",
	            onSubmit: this.submitForm
	          },
	          _react2.default.createElement(
	            _rebass.Flex,
	            { flexDirection: ["column", null, "row"], mb: 2 },
	            _react2.default.createElement(
	              _rebass.Box,
	              {
	                mr: [0, null, 1],
	                width: [1 / 1, null, 1 / 2],
	                mb: [2, null, 0]
	              },
	              _react2.default.createElement(_components.Input, { name: "Name", type: "text", placeholder: "Name", required: true })
	            ),
	            _react2.default.createElement(
	              _rebass.Box,
	              { ml: [0, null, 1], width: [1 / 1, null, 1 / 2] },
	              _react2.default.createElement(_components.Input, {
	                name: "Email",
	                type: "email",
	                placeholder: "Email",
	                required: true
	              })
	            )
	          ),
	          _react2.default.createElement(_components.Input, {
	            name: "Organization",
	            type: "text",
	            placeholder: "Organization you represent",
	            required: true
	          }),
	          _react2.default.createElement("input", {
	            name: "URL",
	            type: "text",
	            value: this.state.location,
	            hidden: true
	          }),
	          _react2.default.createElement(
	            _styledComponents.ThemeProvider,
	            { theme: _invertTheme2.default },
	            _react2.default.createElement(
	              _rebass.Box,
	              { mt: 2 },
	              _react2.default.createElement(
	                _components.PrimaryButton,
	                null,
	                "Sign Up"
	              )
	            )
	          )
	        ),
	        this.state.submitted && _react2.default.createElement(
	          _components.H3,
	          { color: "white" },
	          "Thanks for submitting your support! We'll keep you updated on the campaign."
	        )
	      )
	    );
	  };
	
	  return Form;
	}(_react2.default.Component);

/***/ }),

/***/ 291:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _Form = __webpack_require__(290);
	
	Object.keys(_Form).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _Form[key];
	    }
	  });
	});

/***/ }),

/***/ 292:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.Hero = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _rebass = __webpack_require__(4);
	
	var _components = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Hero = exports.Hero = function Hero(props) {
	  if (props.primary) {
	    return _react2.default.createElement(
	      _rebass.Box,
	      { bg: "white" },
	      _react2.default.createElement(
	        _rebass.Box,
	        {
	          w: "100%",
	          mx: "auto",
	          pt: [137, 80],
	          pb: [4, 5, 6],
	          px: [4, 5, 6, 8],
	          style: { maxWidth: "90em" }
	        },
	        _react2.default.createElement(
	          _rebass.Flex,
	          {
	            is: "section",
	            flexDirection: ["column", null, "row"],
	            align: "center",
	            mt: [5, 6],
	            mb: [5, 6]
	          },
	          _react2.default.createElement(
	            _rebass.Box,
	            {
	              position: "relative",
	              style: { zIndex: 1 },
	              w: [1, null, 1 / 2],
	              mb: [5, null, 0],
	              mr: [0, null, 4],
	              pr: [0, null, 4]
	            },
	            props.primary.title && props.primary.title[0] && _react2.default.createElement(_components.H1, {
	              children: props.primary.title[0].text,
	              mb: 5,
	              mr: [0, null, -10],
	              fontSize: [6, 7]
	            }),
	            props.primary.subtitle && props.primary.subtitle[0] && _react2.default.createElement(_components.Text, {
	              children: props.primary.subtitle[0].text,
	              fontSize: [2, 3],
	              mb: 48
	            }),
	            props.primary.button_label && props.primary.button_link && _react2.default.createElement(_components.PrimaryButton, {
	              children: props.primary.button_label,
	              is: "a",
	              href: props.primary.button_link
	            })
	          ),
	          _react2.default.createElement(
	            _rebass.Box,
	            { w: [1, null, 1 / 2], position: "relative", style: { zIndex: 0 } },
	            _react2.default.createElement(
	              _components.GradientCard,
	              {
	                image: props.primary.image ? props.primary.image.half.url : ""
	              },
	              _react2.default.createElement(_rebass.Box, { pb: "100%" })
	            )
	          )
	        )
	      )
	    );
	  } else {
	    return null;
	  }
	};

/***/ }),

/***/ 293:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _Hero = __webpack_require__(292);
	
	Object.keys(_Hero).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _Hero[key];
	    }
	  });
	});

/***/ }),

/***/ 294:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.InternalUpdates = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _moment = __webpack_require__(23);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _components = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var InternalUpdates = exports.InternalUpdates = function InternalUpdates(props) {
	  return _react2.default.createElement(
	    _components.PageSection,
	    { column: "true", borderTop: "true" },
	    _react2.default.createElement(_components.H2, {
	      children: props.primary && props.primary.title && props.primary.title[0] && props.primary.title[0].text,
	      mb: 5,
	      fontSize: [4, 5]
	    }),
	    _react2.default.createElement(
	      _components.CardLayout,
	      { w: 1 / 1 },
	      props.updates && props.updates.edges && props.updates.edges.sort(function (a, b) {
	        if ((0, _moment2.default)(a.node.data.publish_date).utc() < (0, _moment2.default)(b.node.data.publish_date).utc()) return 1;
	        if ((0, _moment2.default)(a.node.data.publish_date).utc() > (0, _moment2.default)(b.node.data.publish_date).utc()) return -1;
	        return 0;
	      }).slice(0, 4).map(function (update, index) {
	        return _react2.default.createElement(_components.UpdateCard, { key: "update" + index, object: update.node });
	      })
	    )
	  );
	};

/***/ }),

/***/ 295:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _InternalUpdates = __webpack_require__(294);
	
	Object.keys(_InternalUpdates).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _InternalUpdates[key];
	    }
	  });
	});

/***/ }),

/***/ 296:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.Quote = undefined;
	
	var _templateObject = _taggedTemplateLiteralLoose(["\n  width: 128px;\n  min-width: 128px;\n  height: 128px;\n  min-height: 128px;\n  border-radius: 9999px;\n  background: ", ";\n  background-size: cover;\n  background-repeat: no-repeat;\n  background-position: center;\n  background-image: ", ";\n"], ["\n  width: 128px;\n  min-width: 128px;\n  height: 128px;\n  min-height: 128px;\n  border-radius: 9999px;\n  background: ", ";\n  background-size: cover;\n  background-repeat: no-repeat;\n  background-position: center;\n  background-image: ", ";\n"]),
	    _templateObject2 = _taggedTemplateLiteralLoose(["\n  position: absolute;\n  top: 0px;\n  margin-top: -12px;\n  left: 0px;\n  margin-left: -32px;\n"], ["\n  position: absolute;\n  top: 0px;\n  margin-top: -12px;\n  left: 0px;\n  margin-left: -32px;\n"]);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(5);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _rebass = __webpack_require__(4);
	
	var _components = __webpack_require__(7);
	
	var _invertTheme = __webpack_require__(12);
	
	var _invertTheme2 = _interopRequireDefault(_invertTheme);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var Avatar = (0, _styledComponents2.default)(_rebass.Box)(_templateObject, function (props) {
	  return props.theme.colors.grey[1];
	}, function (props) {
	  return "url(" + props.image + ")";
	});
	
	var QuoteTicks = function QuoteTicks() {
	  return _react2.default.createElement(
	    "svg",
	    {
	      width: "131",
	      height: "90",
	      viewBox: "0 0 131 90",
	      fill: "none",
	      xmlns: "http://www.w3.org/2000/svg"
	    },
	    _react2.default.createElement("path", {
	      d: "M26.7174 0H67.5L55.8478 90H0.5L26.7174 0Z",
	      fill: "#EBEBEB",
	      fillOpacity: "0.15"
	    }),
	    _react2.default.createElement("path", {
	      d: "M104.283 90L63.5 90L75.1522 2.79073e-06L130.5 7.62939e-06L104.283 90Z",
	      fill: "#EBEBEB",
	      fillOpacity: "0.15"
	    })
	  );
	};
	
	var QuoteWrapper = (0, _styledComponents2.default)(_rebass.Box)(_templateObject2);
	
	var Quote = exports.Quote = function Quote(props) {
	  return _react2.default.createElement(
	    _styledComponents.ThemeProvider,
	    { theme: _invertTheme2.default },
	    _react2.default.createElement(
	      _components.PageSection,
	      null,
	      _react2.default.createElement(
	        _rebass.Box,
	        { bg: "ash", py: 3 },
	        _react2.default.createElement(
	          _rebass.Flex,
	          {
	            flexDirection: ["column", null, "row"],
	            borderTop: "1px solid",
	            borderColor: "grey.0",
	            py: [4, 5, 6]
	          },
	          props.primary.headshot && props.primary.headshot.quarter && props.primary.headshot.quarter.url && _react2.default.createElement(
	            _rebass.Box,
	            { mr: [0, 7, 8], mb: [6, 0, 0] },
	            _react2.default.createElement(Avatar, { image: props.primary.headshot.quarter.url })
	          ),
	          _react2.default.createElement(
	            _rebass.Box,
	            { style: { position: "relative" } },
	            _react2.default.createElement(
	              QuoteWrapper,
	              null,
	              _react2.default.createElement(QuoteTicks, null)
	            ),
	            props.primary.quote && _react2.default.createElement(
	              _components.H2,
	              { mb: 4 },
	              props.primary.quote
	            ),
	            props.primary.author && _react2.default.createElement(
	              _components.H3,
	              { mb: 1 },
	              props.primary.author
	            ),
	            props.primary.role && _react2.default.createElement(
	              _components.H4,
	              null,
	              props.primary.role
	            )
	          )
	        )
	      )
	    )
	  );
	};

/***/ }),

/***/ 297:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _Quote = __webpack_require__(296);
	
	Object.keys(_Quote).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _Quote[key];
	    }
	  });
	});

/***/ }),

/***/ 298:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.RichText = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _prismicDom = __webpack_require__(10);
	
	var _rebass = __webpack_require__(4);
	
	var _components = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var linkResolver = function linkResolver(doc) {
	  return "/" + doc.type;
	};
	
	var RichText = exports.RichText = function RichText(props) {
	  return _react2.default.createElement(
	    _components.PageSection,
	    { column: "true", borderTop: "true" },
	    _react2.default.createElement(
	      _rebass.Flex,
	      {
	        is: "section",
	        flexDirection: ["column", null, "row"],
	        mt: [5, 6],
	        mb: [5, 6]
	      },
	      _react2.default.createElement(
	        _rebass.Box,
	        {
	          w: [1, null, 1 / 2],
	          mb: [5, null, 0],
	          mr: [0, null, 4],
	          pr: [0, null, 4]
	        },
	        props.primary.title && props.primary.title[0] && _react2.default.createElement(_components.H2, { children: props.primary.title[0].text, color: "violet" })
	      ),
	      _react2.default.createElement(
	        _rebass.Box,
	        {
	          w: [1, null, 1 / 2],
	          mb: [5, null, 0],
	          mr: [0, null, 4],
	          pr: [0, null, 4]
	        },
	        props.primary.content && props.primary.content[0] && _react2.default.createElement(_components.Article, {
	          dangerouslySetInnerHTML: {
	            __html: _prismicDom.RichText.asHtml(props.primary.content, linkResolver)
	          }
	        })
	      )
	    )
	  );
	};

/***/ }),

/***/ 299:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _RichText = __webpack_require__(298);
	
	Object.keys(_RichText).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _RichText[key];
	    }
	  });
	});

/***/ }),

/***/ 300:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.SideBySide = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _prismicDom = __webpack_require__(10);
	
	var _rebass = __webpack_require__(4);
	
	var _components = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var linkResolver = function linkResolver(doc) {
	  return "/" + doc.type;
	};
	
	var SideBySide = exports.SideBySide = function SideBySide(props) {
	  if (props.primary) {
	    return _react2.default.createElement(
	      _rebass.Box,
	      { bg: "white" },
	      _react2.default.createElement(
	        _rebass.Box,
	        {
	          w: "100%",
	          mx: "auto",
	          pt: [32, 48],
	          px: [4, 5, 6, 8],
	          style: { maxWidth: "90em" }
	        },
	        _react2.default.createElement(
	          _rebass.Flex,
	          {
	            is: "section",
	            flexDirection: ["column", null, "row"],
	            align: "center",
	            mt: [3, 4],
	            mb: [3, 4]
	          },
	          props.primary.variant === "Image on Left" && _react2.default.createElement(
	            _rebass.Box,
	            {
	              is: "a",
	              href: props.primary.image_link && props.primary.image_link.url,
	              w: [1, null, 1 / 2],
	              mr: [0, 0, 7, 8]
	            },
	            _react2.default.createElement(_rebass.Image, {
	              srcSet: props.primary.image.quarter.url + " 1000w, " + props.primary.image.half.url + " 2000w, " + props.primary.image.url + " 2500w",
	              style: { width: "100%" },
	              alt: props.alt
	            })
	          ),
	          (!props.primary.alt_image || !props.primary.alt_image.url) && _react2.default.createElement(
	            _rebass.Flex,
	            {
	              flexDirection: "column",
	              justifyContent: "center",
	              w: [1, null, 1 / 2],
	              px: [0, 5, 6],
	              py: [4, 0, 0]
	            },
	            props.primary.title && props.primary.title[0] && _react2.default.createElement(_components.H2, {
	              children: props.primary.title[0].text,
	              mb: 5,
	              color: "violet"
	            }),
	            props.primary.content && props.primary.content[0] && props.primary.content[0].text && _react2.default.createElement(
	              _rebass.Box,
	              { mb: 32 },
	              _react2.default.createElement(_components.Article, {
	                dangerouslySetInnerHTML: {
	                  __html: _prismicDom.RichText.asHtml(props.primary.content, linkResolver)
	                }
	              })
	            ),
	            props.primary.button_text && props.primary.button_link && _react2.default.createElement(
	              _rebass.Box,
	              null,
	              _react2.default.createElement(_components.PrimaryButton, {
	                children: props.primary.button_text,
	                is: "a",
	                href: props.primary.button_link
	              })
	            )
	          ),
	          (props.primary.variant === "Image on Right" || props.primary.alt_image && props.primary.alt_image.url) && _react2.default.createElement(
	            _rebass.Box,
	            {
	              is: "a",
	              href: props.primary.alt_image && props.primary.alt_image.url ? props.primary.alt_image_link.url : props.primary.image_link && props.primary.image_link.url,
	              w: [1, null, 1 / 2],
	              ml: [0, 0, 7, 8],
	              mt: props.primary.alt_image && props.primary.alt_image.url ? [4, 0] : 0
	            },
	            _react2.default.createElement(_rebass.Image, {
	              srcSet: props.primary.alt_image && props.primary.alt_image.url ? props.primary.alt_image.quarter.url + " 1000w, " + props.primary.alt_image.half.url + " 2000w, " + props.primary.alt_image.url + " 2500w" : props.primary.image.quarter.url + " 1000w, " + props.primary.image.half.url + " 2000w, " + props.primary.image.url + " 2500w",
	              style: { width: "100%" },
	              alt: props.alt
	            })
	          )
	        )
	      )
	    );
	  } else {
	    return null;
	  }
	};

/***/ }),

/***/ 301:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _SideBySide = __webpack_require__(300);
	
	Object.keys(_SideBySide).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _SideBySide[key];
	    }
	  });
	});

/***/ }),

/***/ 302:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.Stats = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(5);
	
	var _rebass = __webpack_require__(4);
	
	var _components = __webpack_require__(7);
	
	var _theme = __webpack_require__(13);
	
	var _theme2 = _interopRequireDefault(_theme);
	
	var _invertTheme = __webpack_require__(12);
	
	var _invertTheme2 = _interopRequireDefault(_invertTheme);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Stats = exports.Stats = function Stats(props) {
	  return _react2.default.createElement(
	    _components.PageSection,
	    null,
	    _react2.default.createElement(
	      _rebass.Flex,
	      { width: 1 / 1, flexWrap: "wrap", ml: -4, mt: -4, py: [4, 5, 6] },
	      props.items && props.items.map(function (card, index) {
	        return _react2.default.createElement(
	          _rebass.Flex,
	          {
	            width: index % 5 === 0 || index % 5 === 1 ? [1 / 1, 1 / 2, 1 / 2] : [1 / 1, 1 / 3, 1 / 3],
	            pl: 4,
	            pt: 4,
	            key: "card-" + index,
	            height: "100%"
	          },
	          _react2.default.createElement(
	            _styledComponents.ThemeProvider,
	            {
	              theme: index % 5 === 0 || index % 5 === 2 || index % 5 === 4 ? _invertTheme2.default : _theme2.default
	            },
	            _react2.default.createElement(
	              _rebass.Flex,
	              {
	                flexDirection: "column",
	                justifyContent: "space-between",
	                height: "100%",
	                style: { position: "relative" },
	                p: 4,
	                bg: index % 5 === 0 || index % 5 === 4 ? "violet" : index % 5 === 2 ? "ash" : "grey.1"
	              },
	              _react2.default.createElement(
	                _rebass.Box,
	                null,
	                _react2.default.createElement(_components.H4, { children: "Stat" }),
	                card.stat && card.stat[0] && _react2.default.createElement(_components.H2, {
	                  children: card.stat[0].text,
	                  pt: [2, 3],
	                  pb: index % 5 === 0 || index % 5 === 1 ? [2, 3, 4] : [4, 5, 6],
	                  fontSize: [6, 7]
	                })
	              ),
	              card.stat_description && _react2.default.createElement(_components.H3, { children: card.stat_description, fontSize: [2, 3] })
	            )
	          )
	        );
	      })
	    )
	  );
	};

/***/ }),

/***/ 303:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _Stats = __webpack_require__(302);
	
	Object.keys(_Stats).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _Stats[key];
	    }
	  });
	});

/***/ }),

/***/ 304:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _CalloutCards = __webpack_require__(287);
	
	Object.defineProperty(exports, "CalloutCards", {
	  enumerable: true,
	  get: function get() {
	    return _CalloutCards.CalloutCards;
	  }
	});
	
	var _ExternalUpdates = __webpack_require__(289);
	
	Object.defineProperty(exports, "ExternalUpdates", {
	  enumerable: true,
	  get: function get() {
	    return _ExternalUpdates.ExternalUpdates;
	  }
	});
	
	var _Form = __webpack_require__(291);
	
	Object.defineProperty(exports, "Form", {
	  enumerable: true,
	  get: function get() {
	    return _Form.Form;
	  }
	});
	
	var _Hero = __webpack_require__(293);
	
	Object.defineProperty(exports, "Hero", {
	  enumerable: true,
	  get: function get() {
	    return _Hero.Hero;
	  }
	});
	
	var _InternalUpdates = __webpack_require__(295);
	
	Object.defineProperty(exports, "InternalUpdates", {
	  enumerable: true,
	  get: function get() {
	    return _InternalUpdates.InternalUpdates;
	  }
	});
	
	var _Quote = __webpack_require__(297);
	
	Object.defineProperty(exports, "Quote", {
	  enumerable: true,
	  get: function get() {
	    return _Quote.Quote;
	  }
	});
	
	var _RichText = __webpack_require__(299);
	
	Object.defineProperty(exports, "RichText", {
	  enumerable: true,
	  get: function get() {
	    return _RichText.RichText;
	  }
	});
	
	var _SideBySide = __webpack_require__(301);
	
	Object.defineProperty(exports, "SideBySide", {
	  enumerable: true,
	  get: function get() {
	    return _SideBySide.SideBySide;
	  }
	});
	
	var _Stats = __webpack_require__(303);
	
	Object.defineProperty(exports, "Stats", {
	  enumerable: true,
	  get: function get() {
	    return _Stats.Stats;
	  }
	});

/***/ })

});


// WEBPACK FOOTER //
// component---src-layouts-landing-page-js-1ae34c191886b52edbea.js